export enum GettersTypes {
  tickets = 'TICKETS',
  ticketToken = 'TICKET_TOKEN'
}

export const ticketsGetters = {
  [GettersTypes.tickets]: (data) => data?.tickets,
  [GettersTypes.ticketToken]: (data) => data?.ticketToken
}
